import { Input as InputForm } from "@/components/Input";
import { useLoading } from "@/contexts/LoadingContext";
import { useBasicHasRegister, useForgotPassword } from "@/hooks/Auth";
import { useEmpty } from "@/utilsV2";
import {
  Button,
  Center,
  Divider,
  Flex,
  Input,
  Link,
  Text,
  useBreakpointValue,
  useToast
} from "@chakra-ui/react";
import Router from "next/router";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";

function CardRequestNewPasswordIdent(logs) {
  const { setActionIsLoading } = useLoading();
  const [Email, setEmail] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const emailAutoCompleteRef = useRef<any>(null);

  const toast = useToast({
    position: "bottom",
    duration: 5000,
    isClosable: true
  });
  const { handleSubmit, register } = useForm();

  const HandleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    e.stopPropagation();

    if (useEmpty(Email)) {
      setIsLoading(false);
      toast({
        title: "É necessário informar seu Email!",
        status: "error"
      });
      return false;
    }

    const [HasRegisterData, HasRegisterError, HasRegisterLoading] = await useBasicHasRegister({
      UserEmail: Email
    });
    if ((HasRegisterData === null && HasRegisterError) || !HasRegisterData.status) {
      setIsLoading(false);
      toast({
        title: HasRegisterError ? HasRegisterError[0] : "Erro ao verificar seu Email!",
        description: HasRegisterError ? HasRegisterError[1] : HasRegisterData.msgs[0],
        status: "error"
      });
    } else {
      const [SendEmailData, SendEmailError, SendEmailLoading] = await useForgotPassword({
        email: Email,
        created: false,
        site: "LINGLONG",
        referer: null
      });

      if (SendEmailData && SendEmailError === null) {
        setIsLoading(false);
        toast({
          title: "Email enviado com sucesso!",
          description:
            "Verifique sua caixa de entrada! Você será redirecionado para a página inicial.",
          status: "success",
          duration: 8000
        });
        return Router.push("/");
      } else {
        setIsLoading(false);
        toast({
          title: SendEmailError ? SendEmailError[0] : "Erro ao enviar o Email!",
          description: SendEmailError ? SendEmailError[1] : SendEmailData,
          status: "error"
        });
        return false;
      }
    }
  };

  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Flex w="full" justifyContent="center" mt={["20px", "20px"]}>
      <Flex
        width={["90%", "400px"]}
        direction="column"
        alignItems="center"
        as="form"
        onSubmit={HandleSubmit}
      >
        <Text w={"90%"} textAlign={"center"} mb={"15px"}>
          Insira seu e-mail para receber as instruções e link para criar uma nova senha.
        </Text>
        <Input
          w={["full", "400px"]}
          fontWeight={"500"}
          bgColor={"ll-gray.600"}
          fontSize={"text1"}
          border="1px solid"
          borderColor="ll-gray.100"
          borderRadius={"50px"}
          placeholder="E-mail"
          type="email"
          mb="1rem"
          _placeholder={{ color: "gray.300" }}
          _hover={{ border: "1px solid #0C4EA2" }}
          _focus={{
            boxShadow: "none"
          }}
          {...register("email", {
            value: Email,
            onChange: (e) => setEmail(e.target.value)
          })}
        />

        <Flex direction={"column"} alignItems={"center"} mt={"1rem"} w={"full"} gap={"5px"}>
          <Button
            variant={"primary-button"}
            w={"full"}
            loadingText="Enviando..."
            isLoading={IsLoading}
            _hover={{ opacity: "0.5" }}
            type="submit"
          >
            <Text>ENVIAR EMAIL</Text>
          </Button>
          <Link
            mt={["15px", ""]}
            color={"#1E64C3"}
            fontSize={"14px"}
            textStyle={"Regular"}
            onClick={() => {
              logs.setWantCreate(false);
              logs.setWantLogin(true);
              logs.setWantRegister(false);
            }}
          >
            Cancelar
          </Link>
          <Center gap={"15px"}>
            <Divider
              w={["125px", "170px"]}
              colorScheme={"blackAlpha"}
              border={"1px solid "}
              borderColor={"#A9A9A9"}
            />
            <Text my=".5rem">ou </Text>
            <Divider
              w={["125px", "165px"]}
              colorScheme={"blackAlpha"}
              border={"1px solid "}
              borderColor={"#A9A9A9"}
            />
          </Center>
        </Flex>

        <Flex alignItems={"center"} mt={"1rem"} w={"full"} gap={"10px"}>
          <Button
            variant={"secondary-button"}
            w={"full"}
            type={"button"}
            _hover={{ opacity: "80%" }}
            onClick={() => {
              logs.setWantCreate(true);
              logs.setWantLogin(false);
              logs.setWantRegister(false);
            }}
          >
            CADASTRE-SE
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}

export { CardRequestNewPasswordIdent };
